import { Stack, Typography } from '@mui/material';
import HomepPageList from '../../../../../Home/components/FourSolutions/components/HompageList';

const whatYouWillDo = [
  'Research and identify potential clients in industries like marketing, IT, construction, and consulting',
  'Conduct outbound outreach via LinkedIn, email, and calls',
  'Qualify prospects and schedule demos for the senior sales team',
  'Support presales and client onboarding communications',
  'Report performance and optimize outreach strategies',
];

const whatYouBring = [
  'Strong communication and organizational skills',
  'Interest in SaaS, project management, or tech-enabled services',
  'Ability to work independently and hit outreach goals',
  'Bonus: experience in CRM, cold outreach, or B2B tools',
];

const whatWeOffer = [
  <Typography>
    Irish minimum base salary +{' '}
    <Typography variant="publicBody5" component="span">
      commission for each converted license
    </Typography>
  </Typography>,
  'Opportunity to advance in sales or account management',
  'Training, mentorship, and tools to succeed in B2B SaaS sales',
  'Flexible hours and fully remote-friendly setup',
];

const SalesRepresentivePMTool = () => (
  <Stack spacing={3}>
    <Stack>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Location:{' '}
        </Typography>
        Remote or Hybrid (Ireland)(
        <Typography component="span" variant="publicBody4">
          must be a resident of Ireland
        </Typography>
        )
      </Typography>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Type:{' '}
        </Typography>
        Full-time, Entry to Mid-level
      </Typography>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Compensation:{' '}
        </Typography>
        Irish minimum base salary + commission on converted licences
      </Typography>
    </Stack>

    <Typography variant="publicBody4Regular">
      <Typography component="span" variant="publicBody4">
        Eligibility:{' '}
      </Typography>
      <Typography sx={{ fontStyle: 'italic' }} component="span">
        Applicants must currently reside in Ireland and be legally entitled to work in Ireland.
      </Typography>
    </Typography>

    <Stack>
      <Typography variant="publicBody4">About Spona</Typography>
      <Typography variant="publicBody4Regular">
        Spona helps companies manage multiple suppliers and outsourced teams through a single, smart
        platform. With milestone-linked contracts, automated payments, and a unified dashboard,
        Spona replaces outdated spreadsheets and email chaos with structure and control.
      </Typography>
    </Stack>

    <Stack>
      <Typography variant="publicBody4">Your Mission</Typography>
      <Typography variant="publicBody4Regular">
        As the{' '}
        <Typography variant="publicBody4" component="span">
          Sales Development Representative for Spona PM Tool
        </Typography>
        , you’ll connect with decision-makers (CEOs, COOs, PMs) who are managing external partners —
        introducing them to a modern way of working. You’ll turn curiosity into demos and demos into
        customers.
      </Typography>
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What You'll Do:
      </Typography>
      <HomepPageList items={whatYouWillDo} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What You Bring:
      </Typography>
      <HomepPageList items={whatYouBring} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What We Offer:
      </Typography>
      <HomepPageList items={whatWeOffer} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Typography variant="publicBody4Regular">
      <Typography variant="publicBody4" component="span">
        Apply now:{' '}
      </Typography>
      send your CV or short intro to{' '}
      <Typography variant="publicBody4" component="span">
        matija@spona.io{' '}
      </Typography>
      with the subject{' '}
      <Typography sx={{ fontStyle: 'italic' }} component="span">
        “SDR – Project Management"
      </Typography>
    </Typography>
  </Stack>
);

export default SalesRepresentivePMTool;
